<template>
    <div class="lesson-task-page">
        <div class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: `/lesson/${$route.params.lessonUid}/type/task` }">课堂作业
                </el-breadcrumb-item>
                <el-breadcrumb-item>作业记录</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card shadow="never">
                <div class="task-head-title" slot="header">
                    <div class="task-title lr">
                        <h2 v-text="taskData.name"></h2>
                        <div class="generate-final-grade">
                            <el-button size="small" type="success" @click="exportTask">导出课堂作业成绩</el-button>
                        </div>
                    </div>
                    <div class="task-toolbar lr">
                        <p>截至 {{taskData.cutoffTime}}</p>
                        <div class="toolbar-action">
                            <!-- <el-select size="small" v-model="value" placeholder="请选择">
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select> -->
                            <el-input size="small" placeholder="请输入学生姓名" v-model="searchInput"
                                @keyup.enter.native="handSearch">
                                <el-button slot="append" icon="el-icon-search" @click="handSearch"></el-button>
                            </el-input>
                        </div>
                    </div>
                </div>
                <div class="task-tips">
                    <dl class="classify" v-for="item in taskTips" :key="item.id">
                        <dt v-text="item.name"></dt>
                        <dd>
                            <span :class="{
                                cur: true,
                                active: item.value.length < 1
                            }" @click="handClick(item)">不限</span>
                        </dd>
                        <dd>
                            <el-radio-group v-model="item.value" @change="handChange">
                                <el-radio v-for="subItem in item.list" :key="subItem.label" :label="subItem.label">
                                    {{subItem.text}}</el-radio>
                            </el-radio-group>
                        </dd>
                    </dl>
                    <!-- <dl class="classify">
                        <dt>作业字数：</dt>
                        <dd class="range">
                            <el-col :span="5">
                                <el-input type="number" size="mini" v-model="minTaskNum"></el-input>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="5">
                                <el-input type="number" size="mini" v-model="maxTaskNum"></el-input>
                            </el-col>
                        </dd>
                    </dl>
                    <dl class="classify">
                        <dt>批改次数：</dt>
                        <dd class="range">
                            <el-col :span="5">
                                <el-input type="number" size="mini" v-model="minCorrectNum"></el-input>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="5">
                                <el-input type="number" size="mini" v-model="maxCorrectNum"></el-input>
                            </el-col>
                        </dd>
                    </dl>-->
                </div>
                <div class="task-list">
                    <div class="top-tools">
                        <!-- <el-dropdown trigger="click">
                            <el-button type="primary" size="small" :disabled="selectList.length === 0">
                                批量给分
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>统一给分</el-dropdown-item>
                                <el-dropdown-item>区间给分</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown> -->
                        <!-- <el-button type="primary" size="small" :disabled="selectList.length === 0">打回作业</el-button>
                        <el-dropdown trigger="click">
                            <el-button type="primary" size="small" :disabled="selectList.length === 0">
                                下载<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>下载作业文档</el-dropdown-item>
                                <el-dropdown-item>下载选中的报表</el-dropdown-item>
                                <el-dropdown-item>下载全班的报表</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>-->
                    </div>
                    <el-table :class="{
                        'no-expand': taskData.isGroup != 1
                    }" ref="multipleTable" tooltip-effect="dark" stripe style="width: 100%" :data="taskList"
                        row-key="uid" @selection-change="handleSelectionChange">
                        <!-- <el-table-column type="selection" width="48"></el-table-column> -->
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%"
                                    :data="props.row.members" :show-header="false">
                                    <el-table-column prop="username" label="学号"></el-table-column>
                                    <el-table-column prop="nickname" label="姓名"></el-table-column>
                                    <el-table-column label="身份">
                                        <template
                                            slot-scope="scope">{{ scope.row.isLoader != 1 ? '组员' : '组长' }}</template>
                                    </el-table-column>
                                    <el-table-column label="成绩" width="180">
                                        <template slot-scope="scope">
                                            <el-col :span="11">
                                                <el-input size="mini" v-model="scope.row.score" placeholder="-">
                                                </el-input>
                                            </el-col>
                                            <el-col class="line" :span="2">/</el-col>
                                            <el-col :span="11">{{taskData.totalScore}}</el-col>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>

                        <el-table-column v-if="taskData.isGroup != 1" prop="username" label="学号" width="120">
                        </el-table-column>

                        <el-table-column v-if="taskData.isGroup == 1" prop="name" label="组名">
                        </el-table-column>
                        <el-table-column v-else prop="nickname" label="姓名" width="150"></el-table-column>

                        <el-table-column label="成绩" v-if="taskData.isGroup != 1">
                            <template slot-scope="scope">
                                <el-col :span="11">
                                    <el-input size="mini" v-model="scope.row.score" placeholder="-"
                                        @change="scoreChange($event, scope.row.uid)" :disabled="!scope.row.status">
                                    </el-input>
                                </el-col>
                                <el-col class="line" :span="2">/</el-col>
                                <el-col :span="11">{{taskData.totalScore}}</el-col>
                            </template>
                        </el-table-column>
                        <el-table-column label="日期">
                            <template slot-scope="scope">
                                {{ scope.row.submitTime ? scope.row.submitTime : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                <el-tag v-text="scope.row.status===1?'未批阅':scope.row.status===2?'已批阅':'未提交'" size="mini"
                                    :type="scope.row.status===1?'warning':scope.row.status===2?'success':'danger'">
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button size="small" type="text" :disabled="scope.row.status>0?false:true"
                                    @click="markAnnex(scope.row.uid)">进入批阅</el-button>
                                <!-- <el-button size="small" type="text" v-else>催交</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div>
                    <el-pagination style="margin-top:15px" background prev-text="上一页" next-text="下一页"
                        layout="total, prev, pager, next, jumper" :total="page.total" :current-page="page.page"
                        :page-size="page.limit" :pager-count="page.pagerCount" @current-change="handlePageChange" hide-on-single-page>
                    </el-pagination>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { exportExcel } from '@/api/common'
import { open_blank } from '@/utils/router'
import { teacherDetailTask, getTaskStudentList, getGroupTaskStudentList, setTasksScore } from '@/api/lab/tasks'

export default {
    data () {
        return {
            timer: '',
            taskData: {},
            // 分页
            page: {
                page: 1,
                limit: 10,
                total: 0,
                pagerCount: 7
            },
            taskList: [],
            value: '0',
            options: [
                { label: '对学生隐藏成绩', value: '0' },
                { label: '对学生显示成绩', value: '1' }
            ],
            searchInput: '',
            taskTips: [
                {
                    id: '1',
                    name: '提交-状态 :',
                    value: '',
                    list: [
                        { label: '2', text: '已批' },
                        { label: '1', text: '未批' },
                        { label: '-1', text: '未交' }
                    ]
                },
                // {
                //     id: '2',
                //     name: '相似度：',
                //     value: [],
                //     list: [
                //         { label: '1', text: '0-50%' },
                //         { label: '2', text: '50%-70%' },
                //         { label: '3', text: '70%-90%' },
                //         { label: '4', text: '90%-100%' }
                //     ]
                // },
                // {
                //     id: '3',
                //     name: '提交-状态：',
                //     value: [],
                //     list: [
                //         { label: '1', text: '超时交' },
                //         { label: '2', text: '按时交' }
                //     ]
                // }
            ],
            minTaskNum: null,
            maxTaskNum: null,
            minCorrectNum: null,
            maxCorrectNum: null,
            selectList: [], // 选中的列表
        }
    },
    created () {
        this.init()
    },
    computed: {
        ...mapGetters(['isRefresh'])
    },
    mounted () {
        this.timer = setInterval(this.localAdd, 2000);
    },
    beforeDestroy () {
        clearInterval(this.timer);
    },
    methods: {
        ...mapActions(["setRefresh"]),
        handSearch () {
            if (this.taskData.isGroup == 1) { // 小组作业
                this.getGroupTaskStudentList()
            } else { // 个人作业
                this.getTaskStudentList()
            }
        },
        exportTask(){  //导出作业名单
            const { uid } = this.$route.params
            let params = {
                // lessonUid: lessonUid,
                taskUid: uid
            }
            exportExcel('lab/labtask2user',{
                ...params
            })
        },
        handClick (item) {
            item.value = ''
            this.getStudentList()
        },
        handChange () {
            if (this.taskData.isGroup == 1) { // 小组作业
                this.getGroupTaskStudentList()
            } else { // 个人作业
                this.getTaskStudentList()
            }
        },
        // page 改变时会触发
        handlePageChange (page) {
            this.$set(this.page, "page", page);
            this.init();
        },
        init () {
            this.teacherDetailTask()
        },
        //定时器
        localAdd () { //定时器每两秒判断页面是否可以取到localStorage的数据,如果可以,就刷新列表
            if (localStorage.getItem('isRefresh') === 'true') {
                localStorage.setItem('isRefresh', false)
                this.init()
            }
        },
        //查询作业
        teacherDetailTask () {
            teacherDetailTask(this.$route.params.uid).then(res => {
                if (res) {
                    this.taskData = res
                    this.getStudentList()
                }
            })
        },
        getStudentList () {
            if (this.taskData.isGroup == 1) { // 小组作业
                this.getGroupTaskStudentList()
            } else { // 个人作业
                this.getTaskStudentList()
            }
        },
        getTaskStudentList (params = {
            taskUid: this.$route.params.uid,
            sidx: 'll2u.user_id'
        }) {
            const { page, limit } = this.page
            let status = this.taskTips[0].value
            let likeNickname = this.searchInput
            if (status != '')
                params.status = status
            if (likeNickname != '')
                params.likeNickname = likeNickname
            getTaskStudentList({
                ...params,
                page,
                limit
            }).then(res => {
                if (res) {
                    this.page.total = res.totalCount
                    this.taskList = res.list
                }
            })
        },
        getGroupTaskStudentList (params = {
            taskUid: this.$route.params.uid,
            sidx: 'll2u.user_id'
        }) {
            const { page, limit } = this.page
            let status = this.taskTips[0].value
            let likeName = this.searchInput
            if (status != '')
                params.status = status
            if (likeName != '')
                params.likeName = likeName
            getGroupTaskStudentList(page, limit, params).then(res => {
                if (res) {
                    const { totalCount } = res
                    this.$set(this.page, 'total', totalCount)
                    this.taskList = res.list
                }
            })
        },
        handleSelectionChange (val) {
            this.selectList = val
        },
        setTasksScore (uid, score) {
            setTasksScore(uid, score).then(() => {
                this.$message.success("成绩已修改!")
            })
        },
        scoreChange (score, uid) {
            this.setTasksScore(uid, score)
        },
        // 批阅课堂作业
        markAnnex (uid) {
            open_blank({
                name: 'lessonTaskMarking',
                params: {
                    uid
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import url('~@/assets/css/lesson/lesson-task-page.less');
.lesson-task-page {
    .el-breadcrumb {
        line-height: 2em;
        margin-bottom: 12px;
    }
}
</style>
